import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText } from "../../../helpers/StringHelpers"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const BuildingNameField = (props: FormFieldProps<string>) => {
    const {
        defaultValue,
        handleChange,
        isDisabled,
    } = props
    const [value, setValue] = useState(defaultValue ?? ``)
    const { t } = useTranslation(`signup`)
    const REGEX = /^[a-zA-Z0-9_]*/g

    useEffect(() => {
        setValue(defaultValue ?? ``)
    }, [defaultValue])

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (REGEX.test(event.target.value)) {
            setValue(capitaliseText(event.target.value))
            handleChange(capitaliseText(event.target.value))
        }
    }
    return (
        <TextField
            fullWidth
            id="building-name"
            label={ t(`building_name`) }
            value={value}
            onChange= {handleOnChange}
            disabled={isDisabled}
        />
    )
}

export { BuildingNameField }